import * as React from "react";
import { useNotify } from "react-admin";
import {
  Box, Card, CardContent, Typography, TextField, Button, Stack, Alert,
  CircularProgress,
} from "@mui/material";
import StickyNote2Icon from "@mui/icons-material/StickyNote2";
import { httpClient } from "../../api/httpClient";
import { API_BASE_URL } from "../../api/config";

const PatientNotes = () => {
  const [patientId, setPatientId] = React.useState("");
  const [notes, setNotes] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const notify = useNotify();

  const save = async () => {
    if (!patientId.trim() || !notes.trim()) return;
    setLoading(true);
    try {
      await httpClient(`${API_BASE_URL}/patients/${patientId}/notes`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(notes),
      });
      notify("Notes mises à jour", { type: "success" });
    } catch (e) {
      notify(`Erreur : ${e.message}`, { type: "error" });
    } finally {
      setLoading(false);
    }
  };

  const completeOnboarding = async () => {
    if (!patientId.trim()) return;
    try {
      await httpClient(`${API_BASE_URL}/patients/${patientId}/complete-onboarding`, {
        method: "POST",
      });
      notify("Onboarding marqué complet", { type: "success" });
    } catch (e) {
      notify(`Erreur : ${e.message}`, { type: "error" });
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4" sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
        <StickyNote2Icon /> Notes patient & onboarding
      </Typography>
      <Alert severity="info" sx={{ mb: 2 }}>
        Mettre à jour les notes admin d'un patient ou forcer la complétion de
        son onboarding (nécessite que traits + hobbies soient renseignés).
      </Alert>
      <Card>
        <CardContent>
          <Stack spacing={2}>
            <TextField size="small" label="ID patient"
              value={patientId} onChange={(e) => setPatientId(e.target.value)} />
            <TextField multiline minRows={6} fullWidth label="Notes admin"
              value={notes} onChange={(e) => setNotes(e.target.value)}
              placeholder="Notes internes, suivi, remarques..." />
            <Box sx={{ display: "flex", gap: 1 }}>
              <Button variant="contained" onClick={save}
                disabled={loading || !patientId.trim() || !notes.trim()}>
                {loading ? <CircularProgress size={18} /> : "Enregistrer notes"}
              </Button>
              <Button variant="outlined" color="success" onClick={completeOnboarding}
                disabled={!patientId.trim()}>
                Forcer onboarding complet
              </Button>
            </Box>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};

export default { list: PatientNotes };
